module.exports = __webpack_public_path__ + "static/Hager-43f83f7285957bb82db9bd9c8589e301.png";